import '../global.css'
import '@amzn/meridian-tokens/base/font/amazon-ember.css'
import '../meridian-overrides.css'
import '../fonts/figtree.css'

import { setUpRumMonitor } from '@amzn/woot-services-vendor-portal-core/lib/aws-rum'
import { AppLoader } from '@amzn/woot-services-vendor-portal-shared-ui/components'
import { AppProvider } from '@amzn/woot-services-vendor-portal-shared-ui/providers/app'
import { useConfigStore } from '@amzn/woot-services-vendor-portal-shared-ui/stores/config-store'
import type { AppProps } from 'next/app'
import React, { useEffect, useState } from 'react'

let renderedConsoleMessage = false

const App = ({ Component, pageProps }: AppProps) => {
  const [shouldRender, setShouldRender] = useState(false)
  const { hydrate, nextPublicApiMocking, isLoading } = useConfigStore()

  useEffect(() => {
    void (async () => {
      await hydrate()

      if (nextPublicApiMocking) {
        // initMocks requires a 94 KB (compressed) chunk to be loaded
        // using a dynamic import keeps it out of the _app bundle,
        // so it only affects TTL if it's needed
        // TODO: remove from prod build altogether when no longer needed
        void import('@amzn/woot-services-vendor-portal-test-server').then(
          async ({ initMocks }) => {
            await initMocks()
            setShouldRender(!isLoading) // never render before msw
          },
        )
      } else {
        setShouldRender(!isLoading)
      }

      void setUpRumMonitor()
    })()
  }, [isLoading, hydrate, nextPublicApiMocking])

  if (shouldRender && !renderedConsoleMessage) {
    // this message logs when the app renders for the first time - good to know for
    // diagnostic purposes (e.g., rendering before config is loaded will cause issues)
    console.log('%capp rendering', 'color:orangered;font-weight:bold;')
    renderedConsoleMessage = true
  }

  return shouldRender ? (
    <AppProvider>
      <Component {...pageProps} />
    </AppProvider>
  ) : (
    <AppLoader />
  )
}

export default App

// INTEGRATION TEST: app should never render before config store is loaded
